import { MutableRefObject, useCallback, useEffect } from 'react';

export const useClickOutside = (
  refs: Array<MutableRefObject<HTMLElement | null>> | MutableRefObject<HTMLElement | null>,
  callback: () => void,
  activated = true,
) => {
  const handleClickOutside = useCallback(
    (event: MouseEvent) => {
      let clickedOutside: boolean;

      if (Array.isArray(refs)) {
        clickedOutside = refs.every((ref) => !ref.current?.contains(event.target as Node));
      } else {
        clickedOutside = !refs.current?.contains(event.target as Node);
      }

      if (clickedOutside) {
        callback();
      }
    },
    [refs, callback],
  );

  useEffect(() => {
    if (!activated) {
      return;
    }

    document.addEventListener('mousedown', handleClickOutside, {
      capture: true,
      passive: true,
    });

    return () => {
      document.removeEventListener('mousedown', handleClickOutside, {
        capture: true,
      });
    };
  }, [activated, handleClickOutside]);
};
